/**
 * Partners Grid block script.
 *
 * Soft fade-in on the whole section. The desktop marquee handles its own
 * continuous motion via CSS keyframes (with reduced-motion support in the
 * accompanying stylesheet) so we only add the entrance reveal here.
 */

import { revealOnScroll, motionTokens } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-partners-grid').forEach((section) => {
		revealOnScroll(section, {
			duration: motionTokens.durMd,
			distance: 0,
		});
	});
});
